export default __webpack_public_path__ + "static/media/gray-hand.d42b9977.svg";